import { config } from '../config';
import { authHeader } from '../helpers';
import axiosInstance from '../axiosInstance';

export const entityService = {
  getEntityByID,
  addEntity,
  updateEntity,
  deleteEntity,
  getEntityAdminUsers,
  saveEntityAdminUser,
  deleteEntityAdminUser,
  updateEntityAdminUser
};

function getEntityByID(id) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .get(`${config.entity_server}/${id}`, requestOptions)
    .then((response) => response.data);
}

function addEntity(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .post(`${config.entity_server}`, data, requestOptions)
    .then((response) => response.data);
}

function updateEntity(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .put(`${config.entity_server}/${data._id}`, data, requestOptions)
    .then((response) => response.data);
}

function deleteEntity(id) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .delete(`${config.entity_server}/${id}`, requestOptions)
    .then((response) => response.data);
}

function getEntityAdminUsers(entityId) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .get(`${config.entity_server}/${entityId}/adminUsers`, requestOptions)
    .then((response) => response.data);
}

function saveEntityAdminUser(id, data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .post(`${config.entity_server}/${id}/adminUser`, data, requestOptions)
    .then((response) => response.data);
}

function updateEntityAdminUser(id, data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .put(`${config.entity_server}/adminUser/update/${id}`, data, requestOptions)
    .then((response) => response.data);
}

function deleteEntityAdminUser(userId) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .put(`${config.entity_server}/adminUser/remove/${userId}`, {}, requestOptions) // Ensure userId is used
    .then((response) => response.data);
}
